// export const enum KoreanName {
export enum VariableNameTranslate {
  "name" = "모델명",
  "cumulative_return" = "누적 수익률(%)",
  "annual_average_return" = "연평균 수익(%)",
  "winning_percentage" = "승률(%)",
  "max_loss_rate" = "최대 손실률(%)",
  "holdings_count" = "편입 종목수",
}
